export default function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@babel_runtime@7.9.2@@babel/runtime/helpers/esm/iterableToArray.js
// module id = 434
// module chunks = 0